<template>
    <div class="header-layout">
        <dialog-side-nav />
        <v-toolbar dense app flat scroll-off-screen :color="bgcolor">
            <v-layout row d-flex align-center>
                <div class="header">
                    <div class="header__search-field">
                        <v-text-field @keyup.enter="searchProduct()" v-model="search" prepend-inner-icon="fas fa-bars" @click:prepend-inner="dialogSideNav" class="mt-2"
                            placeholder="Search product..." solo flat></v-text-field>
                    </div>
                    <div>
                        <div class="header_icons">
                            <notification></notification>
                            <cart-component></cart-component>
                        </div>
                    </div>
                </div>
            </v-layout>
        </v-toolbar>
        <LoginRegisterModal
                :dialog="loginRegisterModalShow"
                :event-name="'loginClickSidebar'"
                @hide="loginRegisterModalShow = false"
        ></LoginRegisterModal>
        <loader v-if="loading"></loader>
    </div>
</template>

<script>
    import CartComponent from "../components/CartComponent";
    import LoginRegisterModal from "../components/LoginRegisterModal";
    export default {
        components: {LoginRegisterModal, CartComponent},
        props: {
            bgcolor: ''
        },
        data() {
            return {
                text: '',
                bgCover: require('../assets/cover-photo.jpg'),
                loginRegisterModalShow : false,
                search: '',
                loading: false,
            }
        },
        methods: {
            sideBar() {
                this.drawer = true;
                EventBus.$emit('sideBar', true);
            },
            dialogSideNav() {
                if (this.$store.state.user != null){
                    this.dialog = true;
                    EventBus.$emit('dialogSideNav', true);
                }
                else{
                    this.loginRegisterModalShow = true;
                }

            },
            searchProduct()
            {
                if (!this.loading)
                {
                    this.loading = true
                    var req_data = []

                    axios.get('/api/g/product-search?search=' + this.search, req_data)
                        .then(res =>
                    {
                        let data = {}
                        data = res.data.data.data
                        data.forEach((dataz,key) =>
                        {
                            if (dataz.galleries.length)
                            {
                                data[key].primary_image = dataz.galleries[0].url_thumbnail;
                            }
                            else
                            {
                                data[key].primary_image = "";
                            }

                            data[key].price_range = this.getPriceRange(dataz.variations);
                        });

                        EventBus.$emit('onSearch', data);
                        EventBus.$emit('onSearchName', this.search);
                        this.loading = false
                    })
                    .catch(err =>
                    {
                        this.toaster('something went wrong.', 201);
                    })
                    .finally(()=>
                    {

                    });
                }
            },
            getPriceRange(array)
            {
                var min = array[0].price,
                    max = array[0].price

                var range = null

                array.map((response)=>
                {
                    min = response.price < min ? response.price : min
                    max = response.price > max ? response.price : max
                });

                min = Number.parseFloat(min).toFixed(2)
                max = Number.parseFloat(max).toFixed(2)

                if(min == max)
                {
                    range = "P " + this.numberWithCommas(min);
                }
                else
                {
                    range = "P "+ this.numberWithCommas(min) + " - P "+ this.numberWithCommas(max);
                }

                return range
            },
            numberWithCommas(x) {
                return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            },
            putSearchValue() {
                EventBus.$off('putSearchValue');
                EventBus.$on('putSearchValue', (res) => {
                    this.search = res
                });
            }
        },
        mounted(){
            EventBus.$off('loginClickSidebar');
            EventBus.$on('loginClickSidebar', (data)=>{
                this.dialog = true;
                // EventBus.$emit('dialogSideNav', true);
                this.loginRegisterModalShow = false;
            });
            this.putSearchValue()
        }
    }

</script>

<style lang="scss">
    @import "../scss/app.scss";

    .v-badge__badge {
        height   : 1.25rem !important;
        width    : 1.25rem !important;
        font-size: .65rem !important;
    }

    .header-layout {

        .v-text-field.v-text-field--solo .v-input__control {
            min-height: 35px;
            padding: 0;

            .v-icon {
                color: #f10102;
            }
        }

        .header {
            display              : grid;
            grid-template-columns: 1fr auto;
            grid-gap             : 5px;
            align-items          : center;

            .header__search-field {
                input {
                    font-size: 13px;
                }
            }

            .header_icons {
                display              : grid;
                grid-template-columns: auto auto;
                grid-gap             : 8px;
                align-items          : center;
                justify-content      : center;

                .nav-icon {
                    justify-self: end;
                    cursor: pointer;
                }
            }
        }

        .nav-link {
            color          : #2c3e50;
            text-decoration: none;
            margin         : 0.65rem;
            vertical-align : middle;
        }

        .router-link-exact-active {
            color: #42b983;
        }
    }

</style>
